import React from 'react';

const Trope1: React.FC = () => {
  return (
    <g
      className="prefix__trope-decor-1 prefix__trope-decor"
      transform="translate(121.4, 236)"
    >
      <defs>
        <linearGradient
          id="f9f5ad08-db67-4112-9e09-445dfcbce156"
          data-name="grad-21"
          x1="1339.36"
          y1="143.4"
          x2="1163.32"
          y2="143.89"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.3" stopColor="#0d2b6c" />
          <stop offset="0.34" stopColor="#303472" />
          <stop offset="0.4" stopColor="#68427c" />
          <stop offset="0.45" stopColor="#8b4b83" />
          <stop offset="0.48" stopColor="#984e85" />
          <stop offset="0.82" stopColor="#ff9683" />
        </linearGradient>
      </defs>
      <g id="a19c347c-486f-44a9-b426-8b4f822fddab" data-name="road">
        <path
          d="M695.22,59,676.36,73s-101-12-125,8-42,53-65,48-115,5-164,37-245,46-249,107,75,53,75,53l23,3c9,11,70,19,92,30l12,23c-30-18-142-34.52-198-37-74.8-3.31-104.35-86.69-48-117,35.81-26.28,165.65-46.19,182-56,20-12,64-13,123-45s132.51-20.91,142-21c22.61-.22,41.64-20.19,75-39C588,46.34,695.22,59,695.22,59Z"
          fill="#415c93"
        />
        <path
          d="M266.86,368.5s-94-25-141-32-98-40-82-80,136-65,205-81,108-52,157-56,81,1,96-8,30-27,44-35,41-18,82-14,59,2.52,59,2.52"
          fill="none"
          stroke="#dcceea"
          strokeMiterlimit="10"
          strokeDasharray="12"
        />
        <path
          d="M1033.4,138.08l-39,16.56c-14-8.37-69.39-1.6-107.53-11.14-24-6-20.5-23.5-44.5-48.5s-73-17-73-17l13.39-21.4S805.36,55,850.36,73c20.84,8.33,26,20.31,28.66,30.38-.16-1.19-.25-2-.27-2.23.85,4.84,14.25,19.55,30.93,20.2,1,0,1.77.09,2.41.17h0C952.5,122.47,1033.4,138.08,1033.4,138.08Z"
          fill="#415c93"
        />
        <path
          d="M1193.36,187c42-12,83,2,140,3s71-23,72-40-62-63-142-34-121,41-121,41Z"
          fill="#415c93"
        />
        <path
          d="M994.36,155s126,40,77,96c0,0,21-31,54-26,0,0,19-33,68-38l-51-30s-23,12-48,6-61-24-61-24Z"
          fill="#415c93"
        />
        <path
          d="M775.69,66s20.67-3,45.67,7,39.21,10.9,52.5,37.5c17.25,34.55,39.44,21.26,69.5,24.5,32.2,3.47,50.47,4,66.74,11.49,0,0,63.76,20,82.76,36s159-75,228-64,83,51,12,53-146-23-182,13-46,34-46,34"
          fill="none"
          stroke="#dcceea"
          strokeMiterlimit="10"
          strokeDasharray="12"
        />
      </g>
      <g id="e09c6bd7-7e7d-4ffd-ad10-4822ac04f575" data-name="decor">
        <g>
          <image
            width="97"
            height="96"
            transform="translate(126.36 301)"
            xlinkHref="data:image/png;base64,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"
          />
          <polygon
            points="174.8 350.55 174.8 359.48 164.25 344.45 174.8 338.36 174.8 345.88 185.36 351.87 185.36 356.64 174.8 350.55"
            fill="none"
            stroke="#f416ca"
            strokeLinejoin="round"
            strokeWidth="2.13"
          />
          <line
            x1="178.13"
            y1="353.18"
            x2="178.13"
            y2="374.5"
            fill="none"
            stroke="#f416ca"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2.13"
          />
          <line
            x1="178.13"
            y1="353.18"
            x2="178.13"
            y2="374.5"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.3"
          />
          <polygon
            points="174.8 350.55 174.8 359.48 164.25 344.45 174.8 338.36 174.8 345.88 185.36 351.87 185.36 356.64 174.8 350.55"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.3"
          />
        </g>
        <g>
          <polygon
            points="587.84 43.77 587.84 47.5 582.32 40.58 587.84 37.39 587.84 41.32 594.86 40.5 593.86 44.5 587.84 43.77"
            fill="none"
            stroke="#4ff219"
            strokeLinejoin="round"
            strokeWidth="1.11"
          />
          <polygon
            points="587.84 43.77 587.84 47.5 582.32 40.58 587.84 37.39 587.84 41.32 594.86 40.5 593.86 44.5 587.84 43.77"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.15"
          />
          <image
            width="87"
            height="85"
            transform="translate(545.36)"
            xlinkHref="data:image/png;base64,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"
          />
          <line
            x1="589.86"
            y1="44.5"
            x2="589.58"
            y2="56.29"
            fill="none"
            stroke="#4ff219"
            strokeLinejoin="round"
            strokeWidth="1.11"
          />
          <line
            x1="589.86"
            y1="44.5"
            x2="589.58"
            y2="56.29"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.15"
          />
        </g>
        <g>
          <g>
            <path
              d="M675.36,74s36-20,94,4l13.5-20.5S726.36,37,695.36,59Z"
              fill="#415c93"
            />
            <line
              x1="674.86"
              y1="51.5"
              x2="674.86"
              y2="73.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="723.86"
              y1="57.5"
              x2="723.86"
              y2="66.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="733.86"
              y1="39.5"
              x2="733.86"
              y2="48.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="771.86"
              y1="55.5"
              x2="771.86"
              y2="77.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="782.86"
              y1="35.5"
              x2="782.86"
              y2="57.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="694.86"
              y1="37.5"
              x2="694.86"
              y2="59.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <path
              d="M674.86,54.72s24,16.78,49-.22c0,0,15,15,48,5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
            />
            <path
              d="M695.34,40.38s15.52,13.91,38.52,1c0,0,36,16.77,49-3.56"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
            />
          </g>
          <path
            d="M775.69,66S739.22,48.73,689,63.12"
            fill="none"
            stroke="#dcceea"
            strokeMiterlimit="10"
            strokeDasharray="12"
          />
        </g>
        <g>
          <polygon
            points="803.9 68.39 814.63 74.58 814.63 62.19 825.36 80.78 814.63 86.97 814.63 79.11 803.9 73.02 803.9 68.39"
            fill="none"
            stroke="#f916ce"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.24"
          />
          <polygon
            points="803.9 68.39 814.63 74.58 814.63 62.19 825.36 80.78 814.63 86.97 814.63 79.11 803.9 73.02 803.9 68.39"
            fill="none"
            stroke="#f9eff8"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.23"
          />
          <line
            x1="809.78"
            y1="76.36"
            x2="809.78"
            y2="100"
            fill="none"
            stroke="#f916ce"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.24"
          />
          <image
            width="96"
            height="99"
            transform="translate(766.36 25)"
            xlinkHref="data:image/png;base64,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"
          />
        </g>
        <g>
          <polygon
            points="813.84 47.77 813.84 52.44 808.32 44.58 813.84 41.39 813.84 45.32 819.36 48.45 819.36 50.95 813.84 47.77"
            fill="none"
            stroke="#4ff219"
            strokeLinejoin="round"
            strokeWidth="1.11"
          />
          <image
            width="85"
            height="85"
            transform="translate(771.36 4)"
            xlinkHref="data:image/png;base64,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"
          />
          <line
            x1="815.58"
            y1="49.14"
            x2="815.58"
            y2="60.29"
            fill="none"
            stroke="#4ff219"
            strokeLinejoin="round"
            strokeWidth="1.11"
          />
          <line
            x1="815.58"
            y1="49.67"
            x2="815.58"
            y2="60.14"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.15"
          />
          <polygon
            points="813.84 47.77 813.84 52.44 808.32 44.58 813.84 41.39 813.84 45.32 819.36 48.45 819.36 50.95 813.84 47.77"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.16"
          />
        </g>
        <g>
          <polygon
            points="1098.87 116.34 1098.87 125.27 1088.32 110.25 1098.87 104.15 1098.87 111.67 1109.43 117.66 1109.43 122.43 1098.87 116.34"
            fill="none"
            stroke="#4ff219"
            strokeLinejoin="round"
            strokeWidth="2.13"
          />
          <image
            width="97"
            height="96"
            transform="translate(1050.36 67)"
            xlinkHref="data:image/png;base64,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"
          />
          <line
            x1="1102.21"
            y1="118.97"
            x2="1102.21"
            y2="140.29"
            fill="none"
            stroke="#4ff219"
            strokeLinejoin="round"
            strokeWidth="2.13"
          />
          <line
            x1="1102.21"
            y1="119.97"
            x2="1102.21"
            y2="140"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.3"
          />
          <polygon
            points="1098.87 116.34 1098.87 125.27 1088.32 110.25 1098.87 104.15 1098.87 111.67 1109.43 117.66 1109.43 122.43 1098.87 116.34"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.3"
          />
        </g>
        <g>
          <ellipse
            cx="1303.67"
            cy="146.5"
            rx="59.31"
            ry="16.5"
            fill="#324b77"
          />
          <ellipse
            cx="1303.67"
            cy="143.5"
            rx="59.31"
            ry="16.5"
            fill="url(#f9f5ad08-db67-4112-9e09-445dfcbce156)"
          />
          <g opacity="0.71">
            <path
              d="M1278.86,146.5a8.38,8.38,0,0,0-.85.32c-.26.14-.51.33-.51.52,0,.39.61.78,1.08,1.07a22.42,22.42,0,0,0,3.27,1.46c1.13.43,2.28.79,3.44,1.12.58.15,1.17.3,1.76.4a5.49,5.49,0,0,0,1.81.11,7.25,7.25,0,0,1-3.7.09,21.15,21.15,0,0,1-3.59-1,14.54,14.54,0,0,1-3.33-1.7,4.41,4.41,0,0,1-.74-.64,1.21,1.21,0,0,1-.38-1c.14-.44.53-.54.81-.64A4.25,4.25,0,0,1,1278.86,146.5Z"
              fill="#d66e9f"
            />
          </g>
          <g opacity="0.71">
            <path
              d="M1313.86,151.5a66.44,66.44,0,0,1,7.33.29,36.77,36.77,0,0,0,7.26.12,12,12,0,0,0,3.41-.9,9.2,9.2,0,0,0,2.85-2,16.88,16.88,0,0,1,6.09-4.34c1.2-.41,2.37-.7,3.5-1.1l.86-.31a6.6,6.6,0,0,0,.78-.32,1,1,0,0,0,.61-1,3,3,0,0,0-.69-1.41,8.38,8.38,0,0,0-1.2-1.26,20.29,20.29,0,0,0-2.92-2.08,26.62,26.62,0,0,0-6.67-2.79,23,23,0,0,0-7.21-.87,24.26,24.26,0,0,1,14.26,3,16.91,16.91,0,0,1,3.1,2.1,8.69,8.69,0,0,1,1.34,1.37,3.74,3.74,0,0,1,.89,1.84,1.84,1.84,0,0,1-.21,1.18,2.22,2.22,0,0,1-.85.77,8.37,8.37,0,0,1-.9.4l-.87.32c-1.17.42-2.37.74-3.48,1.14a15.94,15.94,0,0,0-5.79,4,10.16,10.16,0,0,1-3.15,2.14,11.44,11.44,0,0,1-3.67.87C1323.51,153,1318.75,151.68,1313.86,151.5Z"
              fill="#31586d"
            />
          </g>
          <g opacity="0.71">
            <path
              d="M1275.86,133.5c-2,.83-4,1.58-6,2.32s-4,1.4-6,2.12a11.62,11.62,0,0,0-2.8,1.33,4.79,4.79,0,0,0-1.91,2.23,3,3,0,0,0,.5,2.8,8.93,8.93,0,0,0,2.26,2.2,8.22,8.22,0,0,1-2.58-2,3.55,3.55,0,0,1-.77-3.22,5.08,5.08,0,0,1,2.08-2.64,12.81,12.81,0,0,1,3-1.48c2-.66,4.07-1.33,6.12-1.95S1273.77,134,1275.86,133.5Z"
              fill="#d66e9f"
            />
          </g>
          <g opacity="0.71">
            <path
              d="M1307.86,133.5c-1.28,0-2.54-.13-3.81-.2s-2.53-.21-3.79-.27c-2.5-.13-5.06-.22-7.26.79a5.43,5.43,0,0,0-.8.4,5.19,5.19,0,0,0-.77.48,11.58,11.58,0,0,1-1.68,1,18.35,18.35,0,0,1-3.67,1.27c-1.24.31-2.49.55-3.72.82a12.56,12.56,0,0,0-1.83.46,1.92,1.92,0,0,0-.78.43c-.23.2-.11.56.11.79a.63.63,0,0,1-.23-.88,2.19,2.19,0,0,1,.8-.59,13,13,0,0,1,1.8-.68c1.22-.37,2.45-.7,3.64-1.09a21.78,21.78,0,0,0,3.45-1.38,12.49,12.49,0,0,0,1.55-1,6.67,6.67,0,0,1,.84-.54,5.76,5.76,0,0,1,.89-.46c2.5-1.1,5.22-.94,7.73-.63S1305.36,133,1307.86,133.5Z"
              fill="#305891"
            />
          </g>
        </g>
        <g>
          <line
            x1="1296.07"
            y1="219.41"
            x2="1310.12"
            y2="211.36"
            fill="none"
            stroke="#72bdc1"
            strokeMiterlimit="10"
            strokeWidth="0.64"
          />
          <path
            d="M1307.13,208.43l-17.92-10.34a7.6,7.6,0,0,1-2.47.4l.07.06,22.12,12.76a.71.71,0,0,0,.4.11.85.85,0,0,0,.35-.08A17.73,17.73,0,0,0,1307.13,208.43Z"
            fill="#548e8c"
          />
          <path
            d="M1309.56,211.59a.79.79,0,0,1-.4-.1L1287,198.72a.82.82,0,0,1-.39-.69.79.79,0,0,1,.39-.69L1298.1,191a.8.8,0,0,1,1.09.29l11.06,19.16a.79.79,0,0,1-.13,1A.8.8,0,0,1,1309.56,211.59ZM1289,198l18.34,10.59-9.17-15.89Z"
            fill="#72bdc1"
          />
          <path
            d="M1310.25,210.4l-11.06-19.15a.7.7,0,0,0-.36-.32c-.3.75-.78,1.33-1.09,2.08l.47-.27,9.17,15.88h0a17.66,17.66,0,0,1,2.55,2.9.62.62,0,0,0,.21-.15A.79.79,0,0,0,1310.25,210.4Z"
            fill="#9cd8d8"
          />
          <g>
            <path
              d="M1305.34,188.38c-5.33-3-9.67-.54-9.65,5.57s4.39,13.61,9.7,16.67,9.64.56,9.64-5.56S1310.67,191.43,1305.34,188.38Z"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="1.95"
            />
            <path
              d="M1305.34,197.34c-1-.6-1.89-.11-1.89,1.09a4.22,4.22,0,0,0,1.9,3.26c1,.6,1.88.11,1.88-1.09A4.15,4.15,0,0,0,1305.34,197.34Z"
              fill="#496277"
            />
            <path
              d="M1337.66,207c-5.33-3.05-9.67-.54-9.64,5.56s4.39,13.62,9.69,16.68,9.65.56,9.65-5.57S1343,210,1337.66,207Z"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="1.95"
            />
            <path
              d="M1337.66,215.32c-1.34-.77-2.43-.14-2.42,1.4a5.4,5.4,0,0,0,2.43,4.2c1.34.77,2.43.14,2.43-1.4A5.38,5.38,0,0,0,1337.66,215.32Z"
              fill="#496277"
            />
            <polyline
              points="1297.82 188.35 1305.34 199.46 1313.86 202.78"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1312.07 211.62 1305.39 200.59 1313.86 207.54"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1305.84 188.67 1305.34 199.46 1301.36 188"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1311.08 195.53 1305.34 199.46 1308.73 191.59"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1313.42 199.01 1305.34 199.46 1305.84 210.36"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="1304.83"
              y1="199.78"
              x2="1302.54"
              y2="208.05"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="1304.56"
              y1="199.01"
              x2="1300.52"
              y2="205.06"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="1303.82"
              y1="199.01"
              x2="1297.82"
              y2="200.59"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="1303.45"
              y1="198.37"
              x2="1296.77"
              y2="197.1"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="1304.32"
              y1="197.96"
              x2="1296.24"
              y2="192.75"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="1328.02"
              y1="212.55"
              x2="1346.62"
              y2="224.09"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1330.98 206.41 1337.66 218.32 1329.17 208.87"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1336.68 206.99 1337.32 217.71 1334.32 206.41"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1342.76 212.06 1337.66 218.32 1340.1 209.24"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1344.35 215.08 1337.66 218.32 1346 219.16"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <path
              d="M1346.62,227c-.34-.19-7.95-7.79-7.95-7.79"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1340.1 229.26 1337.66 218.32 1343.96 229.26"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <polyline
              points="1336.41 228.48 1337.66 218.32 1334.32 225.62 1332 223.06 1337.66 218.32 1329.17 216.33"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="1329.96"
              y1="220.05"
              x2="1337.03"
              y2="218.58"
              fill="none"
              stroke="#496277"
              strokeMiterlimit="10"
              strokeWidth="0.25"
            />
            <line
              x1="1315.35"
              y1="177.22"
              x2="1305.34"
              y2="199.46"
              fill="none"
              stroke="#9e2a4d"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <path
              d="M1310.34,188.35s8.4,2.24,9.88,19.7l17.44,10.27S1335.82,189.07,1310.34,188.35Z"
              fill="none"
              stroke="#9e2a4d"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <polyline
              points="1333.49 194.4 1324 210.23 1321.05 212.72 1324 217.12"
              fill="none"
              stroke="#9e2a4d"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <polyline
              points="1310.34 182.84 1310.34 180.08 1319.83 174.42 1324.67 174.42"
              fill="none"
              stroke="#ff9a76"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <polygon
              points="1328.75 190.7 1335.22 197.1 1337.28 194.4 1328.75 190.7"
              fill="#ff9a76"
              stroke="#ff9a76"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.11"
            />
            <path
              d="M1328,212.55s-4.46.74-5.76-.93-.83-5.24,1.74-4.12S1328,212.55,1328,212.55Z"
              fill="#9e2a4d"
            />
            <path
              d="M1322.54,216.33c-.83.34-3.32,1.56-3.32,1.56l2.34,1.43,3.23-1.61Z"
              fill="#ff9a76"
            />
            <polygon
              points="1319.22 217.9 1319.22 218.58 1321.54 219.95 1321.56 219.32 1319.22 217.9"
              fill="#f2bdad"
            />
            <polygon
              points="1324.79 217.71 1324.79 218.32 1321.54 219.95 1321.56 219.32 1324.79 217.71"
              fill="#a56556"
            />
          </g>
          <g opacity="0.31">
            <path
              d="M1301.25,230.32c-5-2.49-5.66-7-1.45-10s11.76-3.5,16.76-1,5.66,7,1.45,10S1306.26,232.82,1301.25,230.32Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M1307.41,225.85c-1-.48-1.11-1.37-.29-2a3.54,3.54,0,0,1,3.28-.2c1,.48,1.11,1.36.28,2A3.46,3.46,0,0,1,1307.41,225.85Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M1331.71,245.37c-5-2.5-5.66-7-1.45-10s11.76-3.49,16.76-1,5.66,7,1.45,10S1336.72,247.86,1331.71,245.37Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M1337.44,241.21c-1.26-.63-1.43-1.77-.37-2.53a4.55,4.55,0,0,1,4.22-.26c1.26.62,1.42,1.76.36,2.53A4.5,4.5,0,0,1,1337.44,241.21Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1297.12 224.68 1308.86 224.79 1315.81 229.56"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1320.9 223.79 1309.67 224.27 1319.08 227.18"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1301.73 230.56 1308.86 224.79 1298.81 227.52"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1309.3 231.08 1308.86 224.79 1305.31 231.28"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1312.98 231.1 1308.86 224.79 1316.63 219.73"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="1308.81"
              y1="224.26"
              x2="1313.24"
              y2="218.4"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="1308.13"
              y1="224.43"
              x2="1310.08"
              y2="218.38"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="1307.73"
              y1="223.88"
              x2="1305.53"
              y2="218.57"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="1307.08"
              y1="223.92"
              x2="1302.55"
              y2="219.52"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="1307.28"
              y1="224.78"
              x2="1299.28"
              y2="221.3"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="1330.26"
              y1="235.33"
              x2="1348.36"
              y2="243.57"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1327.66 240.62 1339.5 239.71 1328.36 238.04"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1331.18 244.63 1338.89 239.75 1329.49 243.14"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1337.98 246.67 1339.5 239.71 1334.59 246.08"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1340.93 246.36 1339.5 239.71 1344.64 245.57"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M1350.33,242.14c-.31-.16-9.7-2.09-9.7-2.09"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1348.35 236.08 1339.5 239.71 1350.46 238.99"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1345.8 233.7 1339.5 239.71 1342.69 233.55 1339.66 233.08 1339.5 239.71 1333.49 234.31"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="1336.48"
              y1="233.05"
              x2="1339.33"
              y2="239.1"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <line
              x1="1299.05"
              y1="243.43"
              x2="1308.86"
              y2="224.79"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M1304,234.1s6.13,5.21,18.94-2.39l16.59,8S1318.4,252.92,1304,234.1Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1320.78 248.51 1326.47 233.46 1326.57 230 1331.2 230.02"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polyline
              points="1300.18 236.86 1298.28 238.24 1299.58 248.2 1302.23 251.85"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polygon
              points="1315.65 246.78 1323.58 248.47 1322.85 251.36 1315.65 246.78"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M1330.26,235.33s-1.93-3.73-3.79-3.87-4,2-1.88,3.37S1330.26,235.33,1330.26,235.33Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <path
              d="M1329.86,229.32c-.22-.79-.74-3.28-.74-3.28l2.26,1.05.66,3.23Z"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polygon
              points="1329.12 226.04 1329.59 225.7 1331.8 226.76 1331.38 227.09 1329.12 226.04"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
            <polygon
              points="1332.04 230.32 1332.46 230.02 1331.8 226.76 1331.38 227.09 1332.04 230.32"
              fill="none"
              stroke="#321b49"
              strokeMiterlimit="10"
              strokeWidth="0.89"
            />
          </g>
          <path
            d="M1304.24,211l-17.92-10.34a7.6,7.6,0,0,1-2.47.4l.07.06L1306,213.85a.71.71,0,0,0,.4.11.73.73,0,0,0,.35-.09A18.08,18.08,0,0,0,1304.24,211Z"
            fill="#72bdc1"
          />
          <path
            d="M1304.24,210.92l-17.92-10.35a7.34,7.34,0,0,1-2.47.4l.07.06L1306,213.8a.79.79,0,0,0,.4.1.85.85,0,0,0,.35-.08A17.66,17.66,0,0,0,1304.24,210.92Z"
            fill="#548e8c"
          />
          <path
            d="M1299.35,217.81a.79.79,0,0,1-.39-.11l-22.12-12.77a.78.78,0,0,1-.4-.69.79.79,0,0,1,.4-.69l11.06-6.38a.79.79,0,0,1,1.09.29l11,19.15a.8.8,0,0,1-.69,1.2Zm-20.52-13.57,18.35,10.59L1288,199Z"
            fill="#72bdc1"
          />
          <path
            d="M1294,217.18l-17.91-10.34a7.66,7.66,0,0,1-2.48.4l.08.06,22.12,12.77a.78.78,0,0,0,.39.1.86.86,0,0,0,.36-.08A17.79,17.79,0,0,0,1294,217.18Z"
            fill="#72bdc1"
          />
          <path
            d="M1296.92,214.65,1279,204.3a7.4,7.4,0,0,1-2.48.4l.08.06,22.12,12.77a.79.79,0,0,0,.39.11.87.87,0,0,0,.36-.09A17.72,17.72,0,0,0,1296.92,214.65Z"
            fill="#548e8c"
          />
          <path
            d="M1285.92,200.39l8.7-5c.31-.75.79-1.33,1.1-2.08a.78.78,0,0,0-.74,0l-11.06,6.38a.82.82,0,0,0-.39.69.79.79,0,0,0,.32.64,7.6,7.6,0,0,0,2.47-.4Z"
            fill="#69afad"
          />
          <path
            d="M1294,217.18l-17.91-10.34a7.66,7.66,0,0,1-2.48.4l.08.06,22.12,12.77a.78.78,0,0,0,.39.1.86.86,0,0,0,.36-.08A17.79,17.79,0,0,0,1294,217.18Z"
            fill="#548e8c"
          />
          <path
            d="M1296.93,219l-11.06-19.15a.82.82,0,0,0-.36-.33c-.3.76-.79,1.33-1.09,2.08l.47-.27,9.17,15.89,0,0a17.79,17.79,0,0,1,2.56,2.91,1,1,0,0,0,.21-.15A.8.8,0,0,0,1296.93,219Z"
            fill="#9cd8d8"
          />
          <path
            d="M1300,216.62l-11-19.16a.85.85,0,0,0-.36-.32c-.3.75-.79,1.33-1.09,2.08l.46-.27,9.18,15.89,0,0a17.79,17.79,0,0,1,2.56,2.91l.21-.15A.8.8,0,0,0,1300,216.62Z"
            fill="#9cd8d8"
          />
          <path
            d="M1275.71,206.61l8.71-5c.3-.75.79-1.32,1.09-2.08a.82.82,0,0,0-.73,0l-11.06,6.39a.79.79,0,0,0-.08,1.32,7.66,7.66,0,0,0,2.48-.4Z"
            fill="#69afad"
          />
          <path
            d="M1307.13,212.76l-11.06-19.15c-.71-.61-.71-.61-1.71.39-.31.75.57.62.26,1.37l.47-.27,9.17,15.88h0a18.08,18.08,0,0,1,2.55,2.9.6.6,0,0,0,.21-.14A.8.8,0,0,0,1307.13,212.76Z"
            fill="#9cd8d8"
          />
        </g>
      </g>
    </g>
  );
};

export default Trope1;
